import { Box, Button, Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { useTheme, alpha } from '@mui/material/styles';
import { parseDateAndTime } from "./OrderTimeLine";
import { useAppContext } from "../AppContext";

function DetailRow({ label, value, isChip, chipColor, highlight }) {
    return (
        <>
            <Grid item xs={5}>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={7}>
                {isChip ? (
                    <Chip
                        label={value}
                        size="small"
                        sx={{
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            ...(chipColor ? {
                                bgcolor: chipColor.bg,
                                color: chipColor.color,
                                border: 'none',
                            } : {}),
                        }}
                        variant={chipColor ? 'filled' : 'outlined'}
                    />
                ) : (
                    <Typography variant="body2" fontWeight={highlight ? 700 : 500} color={highlight ? 'warning.dark' : 'text.primary'}>
                        {value || '—'}
                    </Typography>
                )}
            </Grid>
        </>
    );
}

export default function OrderDetails({ data, statusBucket, statusColor }) {
    const theme = useTheme();
    const { brand } = useAppContext();
    const statusChipColor = {
        primary: { bg: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.main },
        success: { bg: alpha(theme.palette.success.main, 0.1), color: theme.palette.success.main },
        error: { bg: alpha(theme.palette.error.main, 0.1), color: theme.palette.error.main },
    };

    return (
        <Paper elevation={0} sx={{ overflow: 'hidden' }}>
            <Box sx={{
                px: 3,
                py: 2,
                bgcolor: '#fafafa',
                borderBottom: '1px solid rgba(0,0,0,0.06)',
            }}>
                <Typography fontWeight={700} variant="subtitle1">Order Details</Typography>
            </Box>
            <Grid container spacing={1.5} sx={{ px: 3, py: 2.5 }}>
                <DetailRow label="Current Status" value={statusBucket} isChip chipColor={statusChipColor[statusColor]} />
                <DetailRow label="Order ID" value={`${data?.shippingLabelId?.toUpperCase()}${data?.reference ? ` (${data.reference})` : ''}`} />
                <DetailRow label="Order Placed On" value={parseDateAndTime(data?.createdDate, true)} />
                <DetailRow label="Payment Mode" value={data.paymentMode?.toUpperCase()} isChip />
                <DetailRow label="AWB Number" value={data.waybill?.toUpperCase()} />
                {/* <DetailRow label="Shipping Partner" value={data?.courierPartnerParent?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} /> */}
            </Grid>
            <Divider sx={{ mx: 3 }} />
            <Box sx={{
                px: 3,
                py: 1.5,
                bgcolor: '#fafafa',
                borderBottom: '1px solid rgba(0,0,0,0.06)',
                borderTop: '1px solid rgba(0,0,0,0.06)',
            }}>
                <Typography fontWeight={600} variant="body2" color="text.secondary">Shipping Info</Typography>
            </Box>
            <Grid container spacing={1.5} sx={{ px: 3, py: 2.5 }}>
                <DetailRow label="Current Location" value={data?.currentLocation?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} />
                <DetailRow label="Courier Partner" value={data?.courierPartnerParent?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} />
                <DetailRow label="Invoice Value" value={`Rs. ${Math.round(data?.invoiceValue)}`} />
                {data?.paymentMode?.toUpperCase() === 'COD' && (
                    <DetailRow label="COD Amount" value={`Rs. ${Math.round(data?.codAmount ?? data?.invoiceValue)}`} highlight />
                )}
                <DetailRow label="Pickup Location" value={data?.pickupLocation?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} />
                <DetailRow label="Delivery Location" value={data?.deliveryLocation?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} />
            </Grid>
            {statusBucket === 'Delivered' && brand?.enableReturn && (
                <>
                    <Divider sx={{ mx: 3 }} />
                    <Box sx={{ px: 3, py: 2 }}>
                        <Button
                            variant="outlined"
                            fullWidth
                            href="https://r.proship.in/"
                            target="_blank"
                            rel="noreferrer"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: 2 }}
                        >
                            Want to return this order?
                        </Button>
                    </Box>
                </>
            )}
        </Paper>
    )
}
